import { render, staticRenderFns } from "./InputVectorForm.vue?vue&type=template&id=6ef3a0a4&"
import script from "./InputVectorForm.vue?vue&type=script&lang=js&"
export * from "./InputVectorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports